import React, { useEffect, useState } from 'react'
import { Accordion, Button, Card, Col, Form, Row } from 'react-bootstrap'
import { AccordionEventKey, AccordionSelectCallback } from 'react-bootstrap/esm/AccordionContext'
import { GetAppointmentByIdOutput } from '../../../../Adaptor/TUBSIS/controllers/Appointments/models/getAppointmentModels'
import { GetAppointmentQuestionOutput } from '../../../../Adaptor/TUBSIS/controllers/AppointmentQuestions/models/getAppointmentQuestionsModels'
import { getAppointmentQuestionExcelResult, saveAppointmentQuestions } from '../../../../Adaptor/TUBSIS/controllers/AppointmentQuestions/AppointmentQuestions'

type Props = { appointment: GetAppointmentByIdOutput, propAppointmentQuestions: GetAppointmentQuestionOutput[] }

const PatientAppointmentFNBTQuestions: React.FC<Props> = ({ appointment, propAppointmentQuestions }) => {

    const [activeQuestionAccordion, setActiveQuestionAccordion] = useState<AccordionEventKey | null>(null)

    const toggleQuestionAccordion: AccordionSelectCallback = (eventKey: AccordionEventKey) => {
        setActiveQuestionAccordion(eventKey === activeQuestionAccordion ? null : eventKey)
    }

    const [appointmentId, setAppointmentId] = useState<number | null>(null)
    const [questionGroupPuan, setQuestionGroupPuan] = useState<number | null>(null)
    const [questionGroupPuanValid, setQuestionGroupPuanValid] = useState<boolean>(false)
    const [question4, setQuestion4] = useState<string | null>(null)
    const [question5, setQuestion5] = useState<string | null>(null)
    const [question6, setQuestion6] = useState<string | null>(null)
    const [question7, setQuestion7] = useState<string | null>(null)
    const [question9, setQuestion9] = useState<string | null>(null)
    const [question10, setQuestion10] = useState<string | null>(null)

    const [question4Point, setQuestion4Point] = useState<number | null>(null)
    const [question5Point, setQuestion5Point] = useState<number | null>(null)
    const [question6Point, setQuestion6Point] = useState<number | null>(null)
    const [question7Point, setQuestion7Point] = useState<number | null>(null)
    const [question9Point, setQuestion9Point] = useState<number | null>(null)
    const [question10Point, setQuestion10Point] = useState<number | null>(null)

    const [isValidQuestion4, setIsValidQuestion4] = useState<boolean>(false)
    const [isValidQuestion5, setIsValidQuestion5] = useState<boolean>(false)
    const [isValidQuestion6, setIsValidQuestion6] = useState<boolean>(false)
    const [isValidQuestion7, setIsValidQuestion7] = useState<boolean>(false)
    const [isValidQuestion9, setIsValidQuestion9] = useState<boolean>(false)
    const [isValidQuestion10, setIsValidQuestion10] = useState<boolean>(false)

    const getChoiceValue = (choiceId: number): number => {
        switch (choiceId) {
            case 6:
                return 3;
            case 7:
                return 2;
            case 8:
                return 1;
            case 9:
                return 0;
            case 10:
                return 0;
            case 11:
                return 1;
            case 12:
                return 1;
            case 13:
                return 0;
            case 14:
                return 0;
            case 15:
                return 1;
            case 16:
                return 2;
            case 17:
                return 3;
            case 26:
                return 1;
            case 27:
                return 0;
            case 28:
                return 1;
            case 29:
                return 0;
            default:
                return 0;
        }
    };

    const [appointmentQuestions, setAppointmentQuestions] = useState<GetAppointmentQuestionOutput[] | null>(null)
    
    useEffect(() => {
        if (appointment && appointment.appointmentId > 0) {
            // console.log("burada", JSON.stringify(propAppointmentQuestions))
            if (propAppointmentQuestions && propAppointmentQuestions !== null && propAppointmentQuestions.length > 0) {
                // console.log("girdi", JSON.stringify(propAppointmentQuestions))
                setAppointmentQuestions(propAppointmentQuestions)
                propAppointmentQuestions.forEach(aq => {
                    if (aq.questionId && aq.questionId === 4) {
                        setQuestion4(aq.choiceId.toString())
                        setIsValidQuestion4(true);
                        setQuestion4Point(aq.point)

                    } else if (aq.questionId && aq.questionId === 5) {
                        setQuestion5(aq.choiceId.toString())
                        setIsValidQuestion5(true);
                        setQuestion5Point(aq.point)


                    } else if (aq.questionId && aq.questionId === 6) {
                        setQuestion6(aq.choiceId.toString())
                        setIsValidQuestion6(true);
                        setQuestion6Point(aq.point)

                    } else if (aq.questionId && aq.questionId === 7) {
                        setQuestion7(aq.choiceId.toString())
                        setIsValidQuestion7(true);
                        setQuestion7Point(aq.point)

                    } else if (aq.questionId && aq.questionId === 9) {
                        setQuestion9(aq.choiceId.toString())
                        setIsValidQuestion9(true);
                        setQuestion9Point(aq.point)

                    } else if (aq.questionId && aq.questionId === 10) {
                        setQuestion10(aq.choiceId.toString())
                        setIsValidQuestion10(true);
                        setQuestion10Point(aq.point)
                    }
                });

                const totalPoints = propAppointmentQuestions.filter(q => [4, 5, 6, 7, 9, 10].includes(q.questionId)).reduce((total, aq) => total + aq.point, 0);

                // console.log("burası", totalPoints, propAppointmentQuestions, propAppointmentQuestions.length)
                
                if (propAppointmentQuestions && propAppointmentQuestions !== null && propAppointmentQuestions.length > 0) {
                    // console.log("girdi")
                    setQuestionGroupPuan(totalPoints)
                    setQuestionGroupPuanValid(true)
                } else {
                    setQuestionGroupPuanValid(false)
                }
            }

            setAppointmentId(appointment.appointmentId)

        // })
        // .catch((error) => {
        //     console.error("Error fetching user:", error);
        // });
        }
    }, [appointment])

    const handleUpdate = async () => {
        // Form verilerini güncellemek için gerekli işlemleri burada gerçekleştirin
        // console.log("Form verileri güncellendi:", userData);

        if (!appointmentId) {
            alert("Randevu bilgisine ulaşılamadığı için FNBT Testi kaydedilemedi.")
            return;
        }

        if (!question4 || !question5 || !question6 || !question7 || !question9 || !question10) {
            return;
        }

        if (!isValidQuestion4 || !isValidQuestion5 || !isValidQuestion6 ||
            !isValidQuestion7 || !isValidQuestion9 || !isValidQuestion10) {
            return;
        }

        const requestModel = {
            appointmentQuestionGroup: {
                appointmentId: appointmentId,
                appointmentQuestions: [{
                    questionId: 4,
                    choiceId: parseInt(question4),
                    point: question4Point ?? 0
                }, {
                    questionId: 5,
                    choiceId: parseInt(question5),
                    point: question5Point ?? 0
                }, {
                    questionId: 6,
                    choiceId: parseInt(question6),
                    point: question6Point ?? 0
                }, {
                    questionId: 7,
                    choiceId: parseInt(question7),
                    point: question7Point ?? 0
                }, {
                    questionId: 9,
                    choiceId: parseInt(question9),
                    point: question9Point ?? 0
                }, {
                    questionId: 10,
                    choiceId: parseInt(question10),
                    point: question10Point ?? 0
                }]
            }
        }

        //console.log("rqq",JSON.stringify(requestModel))

        var response = await saveAppointmentQuestions(requestModel)

        if (response.success) {
            alert("FNBT(Nikotin Bağımlılık) Testi kaydedildi.")
        } else {
            alert("FNBT Testi kaydedilirken bir sorun oluştu: " + response.message)
        }
        // window.location.reload()
    }

    const handleOptionClick4 = (optionId: string) => {
        if (question4 === optionId) {
            setQuestion4(null); // Seçiliyse geri al
            setIsValidQuestion4(false)
            setQuestion4Point(0)
            setQuestionGroupPuan(questionGroupPuan??0-getChoiceValue(parseInt(optionId)))
        } else {
            setQuestion4(optionId); // Değilse seç
            setIsValidQuestion4(true)
            setQuestion4Point(getChoiceValue(parseInt(optionId)))
            setQuestionGroupPuan(questionGroupPuan??0+getChoiceValue(parseInt(optionId)))
        }
    };

    const handleOptionClick5 = (optionId: string) => {
        if (question5 === optionId) {
            setQuestion5(null); // Seçiliyse geri al
            setIsValidQuestion5(false)
            setQuestion5Point(0)
            setQuestionGroupPuan(questionGroupPuan??0-getChoiceValue(parseInt(optionId)))
        } else {
            setQuestion5(optionId); // Değilse seç
            setIsValidQuestion5(true)
            setQuestion5Point(getChoiceValue(parseInt(optionId)))
            setQuestionGroupPuan(questionGroupPuan??0+getChoiceValue(parseInt(optionId)))
        }
    };

    const handleOptionClick6 = (optionId: string) => {
        if (question6 === optionId) {
            setQuestion6(null); // Seçiliyse geri al
            setIsValidQuestion6(false)
            setQuestion6Point(0)
            setQuestionGroupPuan(questionGroupPuan??0-getChoiceValue(parseInt(optionId)))
        } else {
            setQuestion6(optionId); // Değilse seç
            setIsValidQuestion6(true)
            setQuestion6Point(getChoiceValue(parseInt(optionId)))
            setQuestionGroupPuan(questionGroupPuan??0+getChoiceValue(parseInt(optionId)))
        }
    };

    const handleOptionClick7 = (optionId: string) => {
        if (question7 === optionId) {
            setQuestion7(null); // Seçiliyse geri al
            setIsValidQuestion7(false)
            setQuestion7Point(0)
            setQuestionGroupPuan(questionGroupPuan??0-getChoiceValue(parseInt(optionId)))
        } else {
            setQuestion7(optionId); // Değilse seç
            setIsValidQuestion7(true)
            setQuestion7Point(getChoiceValue(parseInt(optionId)))
            setQuestionGroupPuan(questionGroupPuan??0+getChoiceValue(parseInt(optionId)))
        }
    };

    const handleOptionClick9 = (optionId: string) => {
        if (question9 === optionId) {
            setQuestion9(null); // Seçiliyse geri al
            setIsValidQuestion9(false)
            setQuestion9Point(0)
            setQuestionGroupPuan(questionGroupPuan??0-getChoiceValue(parseInt(optionId)))
        } else {
            setQuestion9(optionId); // Değilse seç
            setIsValidQuestion9(true)
            setQuestion9Point(getChoiceValue(parseInt(optionId)))
            setQuestionGroupPuan(questionGroupPuan??0+getChoiceValue(parseInt(optionId)))
        }
    };

    const handleOptionClick10 = (optionId: string) => {
        if (question10 === optionId) {
            setQuestion10(null); // Seçiliyse geri al
            setIsValidQuestion10(false)
            setQuestion10Point(0)
            setQuestionGroupPuan(questionGroupPuan??0-getChoiceValue(parseInt(optionId)))
        } else {
            setQuestion10(optionId); // Değilse seç
            setIsValidQuestion10(true)
            setQuestion10Point(getChoiceValue(parseInt(optionId)))
            setQuestionGroupPuan(questionGroupPuan??0+getChoiceValue(parseInt(optionId)))
        }
    };

    const handleExcelResultClick = (appointmentId: number, type: number) => {
        // Butona tıklandığında yapılacak işlemler buraya yazılır
        console.log('Butona tıklandı!');

        if (!appointmentId) {
            alert("Randevu bilgileri getirilemediğinden excel alınamıyor.")
            return;
        }

        getAppointmentQuestionExcelResult(appointmentId, 15002, appointment.appointmentStartDate)//FNBT
    };

    return (

        <Accordion activeKey={activeQuestionAccordion} onSelect={toggleQuestionAccordion}>
            <Card key={'2'}>
                <Card.Header>
                    <div className='d-flex justify-content-between align-items-center w-100'>
                        <Button className='d-flex justify-content-between align-items-center w-100' variant='link' onClick={(e) => toggleQuestionAccordion('2', e)}>
                            <div className='text-left text-gray-700'>{"Nikotin Bağımlılık Testi"}</div>
                            <div className='text-center text-gray-700 fs-7' style={{paddingRight:"55px"}}>{questionGroupPuanValid ? `PUAN: ${questionGroupPuan ?? 0}` : "TEST DOLDURULMADI"}</div>
                            <div className='text-right'></div>
                        </Button>
                        <div></div>
                        <button
                            type="button"
                            about='Excel'
                            title='FNBT Test Sonucunu İndir'
                            className="btn btn-icon btn-bg-light btn-active-color-primary btn-sm"
                            onClick={() => handleExcelResultClick(appointmentId ?? 0, 15002)}>
                            {/* 15001: HAPA Excel Type
                            15002: FNBT Excel Type 
                            15003: WEMİOÖ Excel Type
                        */}
                            <i className="ki-duotone ki-file-down fs-2"><span className="path1"></span><span className="path2"></span></i>
                        </button>
                    </div>
                </Card.Header>
                <Accordion.Collapse eventKey={'2'}>
                    <Card.Body>
                        <Form onSubmit={handleUpdate}>
                            <Row className='mb-14'>
                                <Form.Group as={Col}>
                                    <Form.Label>Uyandıktan ne kadar sonra ilk sigaranızı içiyorsunuz?</Form.Label>
                                    <div className="d-grid gap-2">
                                        <Button
                                            style={{ border: "1px solid #a9a9a9" }}
                                            variant={question4 === '6' ? 'primary' : 'outline-primary'}
                                            onClick={() => handleOptionClick4('6')}
                                        >
                                            Uyandıktan sonraki ilk beş dakika içinde
                                        </Button>
                                        <Button
                                            style={{ border: "1px solid #a9a9a9" }}
                                            variant={question4 === '7' ? 'primary' : 'outline-primary'}
                                            onClick={() => handleOptionClick4('7')}
                                        >
                                            6-30 dakika içinde
                                        </Button>
                                        <Button
                                            style={{ border: "1px solid #a9a9a9" }}
                                            variant={question4 === '8' ? 'primary' : 'outline-primary'}
                                            onClick={() => handleOptionClick4('8')}
                                        >
                                            31-60 dakika içinde
                                        </Button>
                                        <Button
                                            style={{ border: "1px solid #a9a9a9" }}
                                            variant={question4 === '9' ? 'primary' : 'outline-primary'}
                                            onClick={() => handleOptionClick4('9')}
                                        >
                                            Bir saat sonra
                                        </Button>
                                        <Form.Control.Feedback type="invalid" style={{ display: isValidQuestion4 ? 'none' : 'block' }}>
                                            Lütfen seçim yapınız.
                                        </Form.Control.Feedback>
                                    </div>
                                </Form.Group>
                            </Row>

                            <Row className='mb-14'>
                                <Form.Group as={Col}>
                                    <Form.Label>Sigara içmenin yasak olduğu yerlerde, sigara içmemek zor geliyor mu? (Örneğin okul, hastane, sinema, otobüs, toplantı vb)</Form.Label>
                                    <div className="d-grid gap-2">
                                        <Button
                                            style={{ border: "1px solid #a9a9a9" }}
                                            variant={question5 === '11' ? 'primary' : 'outline-primary'}
                                            onClick={() => handleOptionClick5('11')}
                                        >
                                            Evet
                                        </Button>
                                        <Button
                                            style={{ border: "1px solid #a9a9a9" }}
                                            variant={question5 === '10' ? 'primary' : 'outline-primary'}
                                            onClick={() => handleOptionClick5('10')}
                                        >
                                            Hayır
                                        </Button>
                                        <Form.Control.Feedback type="invalid" style={{ display: isValidQuestion5 ? 'none' : 'block' }}>
                                            Lütfen seçim yapınız.
                                        </Form.Control.Feedback>
                                    </div>
                                </Form.Group>
                            </Row>
                            <Row className='mb-14'>
                                <Form.Group as={Col}>
                                    <Form.Label>Hangi sigarayı bırakmak sizin için daha zor, yani hangisi sizin için daha değerli?</Form.Label>
                                    <div className="d-grid gap-2">
                                        <Button
                                            style={{ border: "1px solid #a9a9a9" }}
                                            variant={question6 === '12' ? 'primary' : 'outline-primary'}
                                            onClick={() => handleOptionClick6('12')}
                                        >
                                            Sabah İlk Sigaram
                                        </Button>
                                        <Button
                                            style={{ border: "1px solid #a9a9a9" }}
                                            variant={question6 === '13' ? 'primary' : 'outline-primary'}
                                            onClick={() => handleOptionClick6('13')}
                                        >
                                            Diğerleri
                                        </Button>
                                        <Form.Control.Feedback type="invalid" style={{ display: isValidQuestion6 ? 'none' : 'block' }}>
                                            Lütfen seçim yapınız.
                                        </Form.Control.Feedback>
                                    </div>
                                </Form.Group>
                            </Row>

                            <Row className='mb-14'>
                                <Form.Group as={Col}>
                                    <Form.Label>Her gün ortalama kaç adet sigara içiyorsunuz?</Form.Label>
                                    <div className="d-grid gap-2">
                                        <Button
                                            style={{ border: "1px solid #a9a9a9" }}
                                            variant={question7 === '14' ? 'primary' : 'outline-primary'}
                                            onClick={() => handleOptionClick7('14')}
                                        >
                                            10 veya daha az
                                        </Button>
                                        <Button
                                            style={{ border: "1px solid #a9a9a9" }}
                                            variant={question7 === '15' ? 'primary' : 'outline-primary'}
                                            onClick={() => handleOptionClick7('15')}
                                        >
                                            11 ile 20 arası
                                        </Button>
                                        <Button
                                            style={{ border: "1px solid #a9a9a9" }}
                                            variant={question7 === '16' ? 'primary' : 'outline-primary'}
                                            onClick={() => handleOptionClick7('16')}
                                        >
                                            21 ile 30 arası
                                        </Button>
                                        <Button
                                            style={{ border: "1px solid #a9a9a9" }}
                                            variant={question7 === '17' ? 'primary' : 'outline-primary'}
                                            onClick={() => handleOptionClick7('17')}
                                        >
                                            31 veya daha fazlası
                                        </Button>
                                        <Form.Control.Feedback type="invalid" style={{ display: isValidQuestion7 ? 'none' : 'block' }}>
                                            Lütfen seçim yapınız.
                                        </Form.Control.Feedback>
                                    </div>
                                </Form.Group>
                            </Row>
                            <Row className='mb-14'>
                                <Form.Group as={Col}>
                                    <Form.Label>Uyandığınız ilk saatler içinde, gün içinde içtiğinizden daha çok sigara içiyor musunuz?</Form.Label>
                                    <div className="d-grid gap-2">
                                        <Button
                                            style={{ border: "1px solid #a9a9a9" }}
                                            variant={question9 === '26' ? 'primary' : 'outline-primary'}
                                            onClick={() => handleOptionClick9('26')}
                                        >
                                            Evet
                                        </Button>
                                        <Button
                                            style={{ border: "1px solid #a9a9a9" }}
                                            variant={question9 === '27' ? 'primary' : 'outline-primary'}
                                            onClick={() => handleOptionClick9('27')}
                                        >
                                            Hayır
                                        </Button>
                                        <Form.Control.Feedback type="invalid" style={{ display: isValidQuestion9 ? 'none' : 'block' }}>
                                            Lütfen seçim yapınız.
                                        </Form.Control.Feedback>
                                    </div>
                                </Form.Group>
                            </Row>

                            <Row className='mb-14'>
                                <Form.Group as={Col}>
                                    <Form.Label>Günün büyük bölümünü yatakta geçirmenize neden olacak kadar hasta olsanız bile sigara içer misiniz?</Form.Label>
                                    <div className="d-grid gap-2">
                                        <Button
                                            style={{ border: "1px solid #a9a9a9" }}
                                            variant={question10 === '28' ? 'primary' : 'outline-primary'}
                                            onClick={() => handleOptionClick10('28')}
                                        >
                                            Evet
                                        </Button>
                                        <Button
                                            style={{ border: "1px solid #a9a9a9" }}
                                            variant={question10 === '29' ? 'primary' : 'outline-primary'}
                                            onClick={() => handleOptionClick10('29')}
                                        >
                                            Hayır
                                        </Button>
                                        <Form.Control.Feedback type="invalid" style={{ display: isValidQuestion10 ? 'none' : 'block' }}>
                                            Lütfen seçim yapınız.
                                        </Form.Control.Feedback>
                                    </div>
                                </Form.Group>
                            </Row>

                            <Row className='mb-3 mt-10'>
                                <Form.Group as={Col}>
                                    <Button variant='primary' onClick={handleUpdate}>
                                        Kaydet
                                    </Button>
                                </Form.Group>
                            </Row>
                        </Form>
                    </Card.Body>
                </Accordion.Collapse>
            </Card>
        </Accordion>
    )
}

export default PatientAppointmentFNBTQuestions
